import { deserialise, serialise } from "kitsu-core";

/**
 * Deserializes a JSON:API document into a plain JavaScript object
 * @param document - The JSON:API document to deserialize
 * @returns The deserialized data with flattened structure
 */
export const deserializeJsonApi = <R = unknown>(document: unknown): R => {
  // Deep clone the document to prevent mutation of the original
  const clonedDocument = structuredClone(document);

  return deserialise(clonedDocument, {
    hoistData: true,
  });
};

/**
 * Serializes a JavaScript object into a JSON:API document
 * @param type - The resource type
 * @param data - The data to serialize
 * @param method - HTTP method (default: 'POST')
 * @returns The serialized JSON:API document
 */
export const serializeJsonApi = (
  type: string,
  data: unknown,
  method: string = "POST",
): unknown => {
  // Deep clone the data to prevent mutation of the original
  const clonedData = structuredClone(data);
  return serialise(type, clonedData, method);
};
